import { AfterViewInit, Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
// Ck Editer
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EventService } from 'src/app/core/services/event.service';
import { DevelopmentsService } from '../../../services/developments.services';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { AiIntegrationsService } from 'src/app/core/services/ai-integrations.service';
import { AiUsageLinkStateService } from 'src/app/core/services/ai-usage-link-state.service';
import { PropertyDataService } from 'src/app/core/services/property-data.service';
@Component({
  selector: 'app-advertisement1-developments',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss']
})
export class AdvertisementDevelopmentsComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly titleSoftLimit = 120;
  readonly descriptionGoodMin = 800;
  readonly descriptionExcellentMin = 2500;
  readonly descriptionGoodMax = 4000;

  @Input()
  dataToFormInitAdvertisement: any;
  @Input()
  submitted = false;
  @Input()
  propertyAdvertisementData: any;
  propertyAdvertisementForm!: FormGroup;
  @Input()
  isActive!: BehaviorSubject<number>;
  public editorPT = ClassicEditor;
  public editorEN = ClassicEditor;

  subscriptionSubmitted!: Subscription;
  subscriptions!: Subscription;
  isView = false;
  activeTabSubject$: BehaviorSubject<number>;
  @ViewChild('formElementRef') formElementRef!: ElementRef;
  @ViewChild('titleDescRef') titleDescRef!: ElementRef;
  @ViewChild('statusRef') statusRef!: ElementRef;
  @Input()
  property: any;
  nabTabActive = 0;
  activeId: any;
  securityActive: any;
  loginUser!: { id?: string, role?: { id?: string, name?: string }, stores?: any[] };
  aiLoading: Record<string, boolean> = {};
  aiServiceAvailabilityLoaded = false;
  activatedAiServices = new Set<string>();
  /** Custo do próximo uso (0 quando o primeiro título do imóvel é grátis). */
  aiServiceCosts: Record<string, number> = {};
  /** Custo configurado, para repor depois do uso grátis. */
  aiServiceBaseCosts: Record<string, number> = {};
  aiFreeFirstUse = new Set<string>();
  aiLatestResult: {
    kind: 'TITLE' | 'DESCRIPTION' | 'TRANSLATION';
    headline: string;
    detail?: string;
    preview?: string;
    at: number;
  } | null = null;
  aiTranslationPulse = false;

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private propertiesService: DevelopmentsService,
    private renderer: Renderer2,
    public permissionsService: PermissionsService,
    private translateService: TranslateService,
    private aiService: AiIntegrationsService,
    private aiUsageLink: AiUsageLinkStateService,
    private propertyDataService: PropertyDataService
  ) {
    this.subscriptions = new Subscription();
    this.activeTabSubject$ = new BehaviorSubject<number>(1);
  }

  ngOnInit(): void {
    const { id, role, stores } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores };
    this.activeId = this.dataToFormInitAdvertisement?.activeId;
    this.initFormValidation();
    if (this.canShowAiOptions) {
      this.loadActivatedAiServices();
    } else {
      this.aiServiceAvailabilityLoaded = true;
      this.activatedAiServices = new Set<string>();
    }
  }

  ngAfterViewInit(): void {


    setTimeout(() => {
      let act = 0;
      for (let lang of this.dataToFormInitAdvertisement?.langs) {
        act++;
        if (this.formControlErrorWarnning(lang)) {
          const data: any = {};
          data[`lang${lang.id}_main`] = false;
          this.propertyAdvertisementForm.patchValue(data);
        } else if (this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true) {
          this.activeTabSubject$.next(act);
        }
      }

      this.isActive.asObservable().subscribe(val => {
        if (val > 0) {
          for (let option of this.dataToFormInitAdvertisement?.options) {
            const data: any = {};
            data[`option${option.id}`] = false;
            this.propertyAdvertisementForm.patchValue(data);
          }
        }
      })

      this.subscriptionSubmitted = this.eventService.subscribe('get-data-tab-advertisement-dev', (data) => {
        if (data?.submitted)
          for (let lang of this.dataToFormInitAdvertisement?.langs) {
            if (!this.propertyAdvertisementForm.get(`lang${lang.id}_title`)?.value || this.propertyAdvertisementForm.get(`lang${lang.id}_title`)?.value?.trim()?.length === 0) {
              const title: any = [];
              title[`lang${lang.id}_title`] = 'N/A'
              this.propertyAdvertisementForm.patchValue(title);
              const data: any = {};
              data[`lang${lang.id}_main`] = false;
              this.propertyAdvertisementForm.patchValue(data);
            }
          }
        if (this.dataToFormInitAdvertisement?.langs.length > 0) {

          const l1 = this.dataToFormInitAdvertisement?.langs.filter((lang: any) => {
            return this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true && !this.formControlErrorWarnning(lang);
          });
          if (l1?.length === 0) {
            const l2 = this.dataToFormInitAdvertisement?.langs.filter((lang: any) => {
              return !this.formControlErrorWarnning(lang);
            });
            if (l2?.length > 0) {
              const lang = l2[0];
              const data: any = {};
              data[`lang${lang.id}_main`] = true;
              this.propertyAdvertisementForm.patchValue(data);
            } else {
              const lang = this.dataToFormInitAdvertisement?.langs[0];
              const data: any = {};
              data[`lang${lang.id}_main`] = true;
              this.propertyAdvertisementForm.patchValue(data);
            }

          }
        }

        if (!this.permissionsService.isMaster(this.loginUser.role?.name) && !this.permissionsService.hasPermission('ACTIVATE_PROPERTIES')) {
          this.propertyAdvertisementForm.controls[`option${this.activeId}`].setValue(this.securityActive);
        }

        this.propertyAdvertisementData.data = this.propertyAdvertisementForm.value;
        this.propertyAdvertisementData.errors = this.getFormErrors();
        this.propertyAdvertisementData.valid = this.propertyAdvertisementForm.valid;
        this.submitted = true;
        this.eventService.broadcast('ckeck-warning-add-dev');

      });

      for (let lang of this.dataToFormInitAdvertisement?.langs) {
        const subValueChanges = this.propertyAdvertisementForm.get(`lang${lang.id}_title`)?.valueChanges.pipe(debounceTime(100)).subscribe(() => {
          this.eventService.broadcast('get-data-tab-advertisement-dev');
        });
        this.subscriptions.add(subValueChanges);
      }
      this.isView = true;
      this.submitted = true;

      setTimeout(() => {
        this.setEletemtConfig()
        this.setWarning()
      });
    });


  }

  formControlErrorWarnning(lang: any) {
    let errors: any = this.propertyAdvertisementForm.controls[`lang${lang.id}_title`].errors;
    if (errors && errors['warning']) {
      const data: any = {};
      data[`lang${lang.id}_main`] = false;
      this.propertyAdvertisementForm.patchValue(data);
      return true;
    }
    return false;
  }

  /**
* Form data get
*/
  get form() {
    return this.propertyAdvertisementForm.controls;
  }
  /**
  * Form Validation
  */
  initFormValidation() {
    this.dynamicDataForm();
    this.propertyAdvertisementForm = this.formBuilder.group(this.propertyAdvertisementData.data);

    if (!this.permissionsService.isMaster(this.loginUser.role?.name) && !this.permissionsService.hasPermission('ACTIVATE_PROPERTIES')) {
      this.securityActive = this.propertyAdvertisementForm.controls[`option${this.activeId}`].value;
    }
  }

  dynamicDataForm() {

    if (this.propertyAdvertisementData === undefined || this.propertyAdvertisementData === null)
      this.propertyAdvertisementData = { data: {} };

    for (let option of this.dataToFormInitAdvertisement?.options) {
      const vo = this.propertyAdvertisementData.data[`option${option.id}`] !== undefined ? this.propertyAdvertisementData.data[`option${option.id}`] : null;
      this.propertyAdvertisementData.data[`option${option.id}`] = vo;
    }

    for (let lang of this.dataToFormInitAdvertisement?.langs) {

      const vt = this.propertyAdvertisementData.data[`lang${lang.id}_title`] !== undefined ?
        [this.propertyAdvertisementData.data[`lang${lang.id}_title`], [Validators.required, this.ValidateTitle]] : [null, [Validators.required, this.ValidateTitle]];

      this.propertyAdvertisementData.data[`lang${lang.id}_title`] = vt;

      const vd = this.propertyAdvertisementData.data[`lang${lang.id}_description`] !== undefined ? this.propertyAdvertisementData.data[`lang${lang.id}_description`] : null;

      this.propertyAdvertisementData.data[`lang${lang.id}_description`] = vd;

      this.propertyAdvertisementData.data[`lang${lang.id}_main`] = [this.propertyAdvertisementData.data[`lang${lang.id}_main`] ? this.propertyAdvertisementData.data[`lang${lang.id}_main`] : false];
    }
  }



  ValidateTitle = (control: AbstractControl): { [key: string]: any } | null => {
    if (control?.value === 'N/A' || !control?.value) {
      return { 'warning': true };
    }
    return null;
  }

  getFormErrors(): [] {
    let errors: any = [];
    Object.keys(this.propertyAdvertisementForm.controls).forEach(key => {
      // Get errors of every form control
      let type = this.propertyAdvertisementForm?.get(key)?.errors;
      if (type)
        errors.push({ key: key, type: type });
    });
    return errors;
  }

  onChangeMainLang(id: any) {
    for (let lang of this.dataToFormInitAdvertisement?.langs) {

      if (!this.formControlErrorWarnning(lang)) {
        if (this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true && lang.id === id) {
          const data: any = {};
          data[`lang${lang.id}_main`] = true;
          this.propertyAdvertisementForm.patchValue(data);
        } else {
          const data: any = {};
          data[`lang${lang.id}_main`] = false;
          this.propertyAdvertisementForm.patchValue(data);
        }
      }
    }
  }

  setEletemtConfig() {
    if (!this.permissionsService.checkMasterPermission('EDIT_PROPERTIES', this.property?.store?.id) && !this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'EDIT_PROPERTIES') && this.property) {
      if (this.formElementRef.nativeElement) {

        const tabContent = this.formElementRef.nativeElement.querySelector('.tab-content')
        if (tabContent) {
          this.renderer.setStyle(tabContent, 'pointer-events', 'none')
          const parentElement = tabContent.parentElement;
          if (parentElement) {
            this.renderer.setStyle(parentElement, 'cursor', 'not-allowed')
          }
        }

        const statusAdvert = this.formElementRef.nativeElement.querySelector('.status-advert')
        if (statusAdvert) {
          this.renderer.setStyle(statusAdvert, 'pointer-events', 'none')
          const parentElement = statusAdvert.parentElement;
          if (parentElement)
            this.renderer.setStyle(parentElement, 'cursor', 'not-allowed')
        }
      }
    }
  }
  setWarning() {
    if (this.property?.mainAgent !== this.propertiesService.getUserAuth().id && !this.permissionsService.isMaster(this.propertiesService.getUserAuth().role?.name) && this.property) {
      if (this.formElementRef.nativeElement) {
        const tabContent = this.formElementRef.nativeElement.querySelector('.tab-content')
        if (tabContent) {
          const parentElement = tabContent.parentElement;
          if (parentElement) {
            const warning = parentElement.querySelectorAll('.is-warning')
            if (warning) {
              warning?.forEach((el: any) => {
                this.renderer.removeClass(el, 'is-warning')
              });
            }
          }
        }

      }
    }
  }

  activeIdChangeNabTab() {
    setTimeout(() => {
      this.setWarning()
    });

  }

  activeIdChangeNabTabWithValue(nextId?: number) {
    if (typeof nextId === 'number') this.activeTabSubject$.next(nextId);
    this.activeIdChangeNabTab();
  }

  changeActive(id: any) {
    if (!this.propertyAdvertisementForm.controls[`option${id}`].value) {
      Swal.fire({
        title: this.translateService.instant('t-developments.t-desactivate-all-fractions'),
        text: '',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#f46a6a',
        confirmButtonText: 'OK',
      }).then(result => {
        if (result.value) {

        }
      })
    }
  }

  isOptionVisible(option: any) {
    if (!option?.storeId) return true;
    return this.property?.store?.id === option.storeId;
  }

  checkPermissionsByOption(option: any) {
    if (option?.key === 'Active') {
      return this.permissionsService.checkMasterPermission('ACTIVATE_PROPERTIES', this.property?.store?.id) || this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'ACTIVATE_PROPERTIES');
    } else if (option?.key === 'Highlights') {
      return this.permissionsService.checkMasterPermission('HIGHLIGHT_PROPERTIES', this.property?.store?.id) || this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'HIGHLIGHT_PROPERTIES');
    } else if (option?.key === 'MLS') {
      return this.permissionsService.checkMasterPermission('MLS_PROPERTIES', this.property?.store?.id) || this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'MLS_PROPERTIES');
    } else if (option?.type === 'TAG' || option?.entityId != null) {
      return this.permissionsService.checkMasterPermission('HIGHLIGHT_PROPERTIES', this.property?.store?.id) || this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'HIGHLIGHT_PROPERTIES');
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    // Criação abandonada sem gravar: as chaves não podem ligar-se a outro imóvel.
    if (!this.property?.id) this.aiUsageLink.clear();
    this.eventService.broadcast('get-data-tab-advertisement-dev');
    this.subscriptionSubmitted.unsubscribe();
    this.subscriptions.unsubscribe();
  }

  hasWarning(controlName: string): boolean {
    return !!this.propertyAdvertisementForm?.get(controlName)?.errors?.['warning'];
  }

  isMainLanguage(lang: any): boolean {
    return this.propertyAdvertisementForm?.get(`lang${lang.id}_main`)?.value === true;
  }

  isTranslatedLanguage(lang: any): boolean {
    if (this.isMainLanguage(lang)) return false;
    if (this.isTitleNotFilled(lang)) return false;
    const title = String(this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? '').trim();
    const desc = this.getDescriptionTextLength(lang);
    return title.length > 0 || desc > 0;
  }

  isPendingTranslationLanguage(lang: any): boolean {
    if (this.isMainLanguage(lang)) return false;
    return this.isTitleNotFilled(lang);
  }

  private isTitleNotFilled(lang: any): boolean {
    const title = String(this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? '').trim();
    if (!title) return true;
    return title.toUpperCase() === 'N/A';
  }

  getLangCode(lang: any): string {
    return String(lang?.lang ?? '').toUpperCase();
  }

  getLangName(lang: any): string {
    const providedName = String(lang?.name ?? '').trim();
    if (providedName.length > 0) return providedName;

    const map: Record<string, string> = {
      PT: 'Português',
      EN: 'Inglês',
      FR: 'Francês',
      ES: 'Espanhol',
      DE: 'Alemão',
      IT: 'Italiano',
      NL: 'Holandês',
    };
    const code = this.getLangCode(lang);
    return map[code] ?? code;
  }

  getLangFlag(lang: any): string {
    const sourceFlag = String(lang?.flag ?? '').trim();
    if (sourceFlag.length > 0) return sourceFlag;

    const map: Record<string, string> = {
      PT: 'assets/images/flags/pt.svg',
      EN: 'assets/images/flags/en.svg',
      FR: 'assets/images/flags/fr.svg',
      ES: 'assets/images/flags/es.svg',
      DE: 'assets/images/flags/de.svg',
      IT: 'assets/images/flags/italy.svg',
      NL: 'assets/images/flags/en.svg',
    };
    const code = this.getLangCode(lang);
    return map[code] ?? 'assets/images/flags/en.svg';
  }

  getTitleLength(lang: any): number {
    const value = String(this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? '');
    return value.trim().length;
  }

  getDescriptionTextLength(lang: any): number {
    const html = String(this.propertyAdvertisementForm?.get(`lang${lang.id}_description`)?.value ?? '');
    return html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/\u00A0/g, ' ')
      .trim().length;
  }

  getDescriptionFeedbackKey(lang: any): string {
    const size = this.getDescriptionTextLength(lang);
    if (size === 0) return 'ai-advertisement.feedback.empty';
    if (size < this.descriptionGoodMin) return 'ai-advertisement.feedback.short';
    if (size > this.descriptionGoodMax) return 'ai-advertisement.feedback.long';
    if (size >= this.descriptionExcellentMin) return 'ai-advertisement.feedback.excellent';
    return 'ai-advertisement.feedback.good';
  }

  getDescriptionFeedbackClass(lang: any): string {
    const size = this.getDescriptionTextLength(lang);
    if (size === 0) return 'is-empty';
    if (size < this.descriptionGoodMin || size > this.descriptionGoodMax) return 'is-warning';
    return 'is-good';
  }

  get canShowAiOptions(): boolean {
    if (!this.property) return true;
    return (
      this.permissionsService.checkMasterPermission(
        'EDIT_PROPERTIES',
        this.property?.store?.id,
      ) ||
      this.permissionsService.checkAgentPermission(
        this.property?.mainAgent,
        'EDIT_PROPERTIES',
      )
    );
  }

  private aiIdempotencyKey(prefix: string): string {
    return `${prefix}_${this.property?.id ?? 'new'}_${Date.now()}`;
  }

  private loadActivatedAiServices(options?: { keepAvailability?: boolean }) {
    // `keepAvailability`: só refresca custos, sem desativar os botões entretanto.
    if (!options?.keepAvailability) this.aiServiceAvailabilityLoaded = false;
    // Com o id do imóvel o servidor diz se o próximo título é grátis.
    this.aiService.getServicesWithStatus(this.property?.id).subscribe({
      next: (services) => {
        const activated = new Set<string>();
        const costs: Record<string, number> = {};
        const baseCosts: Record<string, number> = {};
        const freeFirstUse = new Set<string>();
        for (const service of services ?? []) {
          const code = String(service?.code ?? '').toUpperCase();
          if (!code) continue;
          if (service?.activated) activated.add(code);
          if (service?.firstUseFree) freeFirstUse.add(code);
          const effectiveCost = Number(service?.effectiveCreditCost);
          const nextCost = Number(service?.nextUsageCost);
          if (Number.isFinite(effectiveCost)) {
            baseCosts[code] = effectiveCost;
            costs[code] = Number.isFinite(nextCost) ? nextCost : effectiveCost;
            continue;
          }
          if (Number.isFinite(service?.defaultCreditCost)) {
            baseCosts[code] = Number(service.defaultCreditCost);
            costs[code] = Number(service.defaultCreditCost);
          }
        }
        this.aiServiceCosts = costs;
        this.aiServiceBaseCosts = baseCosts;
        this.aiFreeFirstUse = freeFirstUse;
        this.activatedAiServices = activated;
        this.aiServiceAvailabilityLoaded = true;
      },
      error: () => {
        this.activatedAiServices = new Set<string>();
        this.aiServiceAvailabilityLoaded = true;
      },
    });
  }

  canUseAiService(serviceCode: string): boolean {
    if (!this.aiServiceAvailabilityLoaded) return false;
    return this.activatedAiServices.has(String(serviceCode || '').toUpperCase());
  }

  getAiServiceCost(serviceCode: string): number {
    const code = String(serviceCode || '').toUpperCase();
    return Number(this.aiServiceCosts[code] ?? 0);
  }

  /** O próximo uso deste serviço é grátis (ex.: primeiro título do imóvel). */
  isAiServiceFree(serviceCode: string): boolean {
    return this.aiFreeFirstUse.has(String(serviceCode || '').toUpperCase());
  }

  /** Depois do uso grátis o botão volta a mostrar o custo configurado. */
  private markFirstUseConsumed(serviceCode: string) {
    const code = String(serviceCode || '').toUpperCase();
    if (!this.aiFreeFirstUse.delete(code)) return;
    this.aiServiceCosts[code] = Number(this.aiServiceBaseCosts[code] ?? this.aiServiceCosts[code] ?? 0);
  }

  private resolveErrorMessage(payload: any): string {
    return payload?.errorMessage ?? payload?.error?.message ?? payload?.message ?? this.translateService.instant('ai-feedback.genericErrorBody');
  }

  private openGenericAiError(message: string) {
    Swal.fire({
      icon: 'error',
      title: this.translateService.instant('ai-feedback.genericErrorTitle'),
      text: message || this.translateService.instant('ai-feedback.genericErrorBody'),
      confirmButtonText: this.translateService.instant('t-close'),
      confirmButtonColor: 'rgb(54, 69, 116)',
    });
  }

  private typewriterFill(controlName: string, text: string, speed = 18) {
    let i = 0;
    const interval = setInterval(() => {
      i++;
      const patch: any = {};
      patch[controlName] = text.slice(0, i);
      this.propertyAdvertisementForm.patchValue(patch, { emitEvent: false });
      if (i >= text.length) {
        clearInterval(interval);
        const final: any = {};
        final[controlName] = text;
        this.propertyAdvertisementForm.patchValue(final);
      }
    }, speed);
  }

  private setLatestResult(
    kind: 'TITLE' | 'DESCRIPTION' | 'TRANSLATION',
    headline: string,
    detail?: string,
    preview?: string,
  ) {
    this.aiLatestResult = { kind, headline, detail, preview, at: Date.now() };
  }

  generateTitle(lang: any) {
    if (!this.canUseAiService('LISTING_TITLE')) return;
    const key = `title_${lang.id}`;
    this.aiLoading[key] = true;
    const idempotencyKey = this.aiIdempotencyKey(`title_${lang.id}`);
    this.aiService.executeAiService(
      'LISTING_TITLE',
      idempotencyKey,
      this.property?.id,
      this.buildListingContextInputData(),
    ).subscribe({
      next: (res: any) => {
        this.aiLoading[key] = false;
        if (res?.ok && res?.output?.title) {
          if (this.property?.id) {
            // Com imóvel só há um grátis: o próximo já paga.
            this.markFirstUseConsumed('LISTING_TITLE');
          } else {
            // Sem id (criação): guarda a chave para ligar ao imóvel depois de
            // gravar e pergunta ao servidor se o próximo ainda é grátis.
            this.aiUsageLink.track(idempotencyKey);
            this.loadActivatedAiServices({ keepAvailability: true });
          }
          this.typewriterFill(`lang${lang.id}_title`, String(res.output.title), 16);
          this.setLatestResult(
            'TITLE',
            this.translateService.instant('ai-feedback.resultTitleHeadline'),
            this.translateService.instant('ai-feedback.resultTitleDetail', { lang: this.getLangCode(lang) }),
            String(res.output.title),
          );
          return;
        }
        this.openGenericAiError(this.resolveErrorMessage(res));
      },
      error: (err: any) => {
        this.aiLoading[key] = false;
        this.openGenericAiError(this.resolveErrorMessage(err));
      },
    });
  }

  async generateDescription(lang: any) {
    if (!this.canUseAiService('LISTING_DESCRIPTION')) return;
    const agentNotes = await this.promptAgentNotes();
    if (agentNotes === null) return;
    const key = `desc_${lang.id}`;
    this.aiLoading[key] = true;
    const pendingImages = this.propertyDataService.listingImages ?? [];
    const request$ = pendingImages.length
      ? this.aiService.executeListingDescriptionUpload(
          this.aiIdempotencyKey(`desc_${lang.id}`),
          pendingImages,
          this.property?.id,
          this.buildListingContextInputData(agentNotes),
        )
      : this.aiService.executeAiService(
          'LISTING_DESCRIPTION',
          this.aiIdempotencyKey(`desc_${lang.id}`),
          this.property?.id,
          this.buildListingContextInputData(agentNotes),
        );
    request$.subscribe({
      next: (res: any) => {
        this.aiLoading[key] = false;
        if (res?.ok && res?.output?.description) {
          this.typewriterFill(`lang${lang.id}_description`, String(res.output.description), 8);
          this.setLatestResult(
            'DESCRIPTION',
            this.translateService.instant('ai-feedback.resultDescriptionHeadline'),
            this.translateService.instant('ai-feedback.resultDescriptionDetail', { lang: this.getLangCode(lang) }),
            String(res.output.description),
          );
          return;
        }
        this.openGenericAiError(this.resolveErrorMessage(res));
      },
      error: (err: any) => {
        this.aiLoading[key] = false;
        this.openGenericAiError(this.resolveErrorMessage(err));
      },
    });
  }

  private applyTranslations(translations: Record<string, any>): number {
    if (!translations) return 0;
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    let updated = 0;

    for (const lang of langs) {
      const code = String(lang?.lang ?? '').toLowerCase();
      const shortCode = code.slice(0, 2);
      const payload =
        translations?.[code] ??
        translations?.[shortCode] ??
        translations?.[code.toUpperCase()] ??
        translations?.[shortCode.toUpperCase()];

      if (!payload) continue;
      if (payload?.title) {
        this.typewriterFill(`lang${lang.id}_title`, String(payload.title), 14);
        updated++;
      }
      if (payload?.description) {
        this.typewriterFill(`lang${lang.id}_description`, String(payload.description), 8);
        updated++;
      }
    }

    return updated;
  }

  private buildTranslationInputData(): string | undefined {
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    if (!langs.length) return undefined;
    const mainLang =
      langs.find((lang: any) => this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true) ??
      langs[0];
    const sourceCode = String(mainLang?.lang ?? '').toLowerCase();
    const sourceTitle = this.propertyAdvertisementForm.get(`lang${mainLang?.id}_title`)?.value ?? '';
    const sourceDescription = this.propertyAdvertisementForm.get(`lang${mainLang?.id}_description`)?.value ?? '';
    const targets = langs
      .map((lang: any) => String(lang?.lang ?? '').toLowerCase())
      .filter((code: string) => !!code);

    return JSON.stringify({
      source: {
        language: sourceCode,
        title: String(sourceTitle ?? ''),
        description: String(sourceDescription ?? ''),
      },
      targets: [...new Set(targets)],
    });
  }

  private firstNonEmpty(...values: any[]): any {
    for (const value of values) {
      if (value === null || value === undefined) continue;
      if (typeof value === 'string' && !value.trim()) continue;
      if (Array.isArray(value) && value.length === 0) continue;
      return value;
    }
    return undefined;
  }

  private positiveNumber(value: any): number | undefined {
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return undefined;
    return num;
  }

  private positiveInt(value: any): number | undefined {
    const num = this.positiveNumber(value);
    if (num === undefined) return undefined;
    return Math.floor(num);
  }

  private normalizeYear(value: any): number | undefined {
    if (value === null || value === undefined) return undefined;
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value.getFullYear();
    }
    const raw = String(value).trim();
    if (!raw) return undefined;
    const fromDate = new Date(raw);
    if (!Number.isNaN(fromDate.getTime())) return fromDate.getFullYear();
    const asNumber = Number(raw);
    if (Number.isFinite(asNumber) && asNumber > 0) return Math.floor(asNumber);
    return undefined;
  }

  private cleanPayload<T>(payload: T): T | undefined {
    if (payload === null || payload === undefined) return undefined;

    if (Array.isArray(payload)) {
      const cleanedArray = payload
        .map((item) => this.cleanPayload(item))
        .filter((item) => item !== undefined);
      return (cleanedArray.length ? cleanedArray : undefined) as T | undefined;
    }

    if (typeof payload === 'object') {
      const entries = Object.entries(payload as Record<string, any>)
        .map(([key, value]) => [key, this.cleanPayload(value)] as const)
        .filter(([, value]) => value !== undefined);
      if (!entries.length) return undefined;
      return Object.fromEntries(entries) as T;
    }

    if (typeof payload === 'string') {
      const normalized = payload.trim();
      return (normalized.length ? normalized : undefined) as T | undefined;
    }

    return payload;
  }

  private async promptAgentNotes(): Promise<string | null> {
    const result = await Swal.fire({
      title: this.translateService.instant('ai-advertisement.notesTitle'),
      text: this.translateService.instant('ai-advertisement.notesHint'),
      input: 'textarea',
      inputPlaceholder: this.translateService.instant('ai-advertisement.notesPlaceholder'),
      inputAttributes: { maxlength: '600' },
      showCancelButton: true,
      confirmButtonText: this.translateService.instant('ai-advertisement.notesConfirm'),
      cancelButtonText: this.translateService.instant('t-cancel'),
      confirmButtonColor: 'rgb(64, 81, 137)',
      cancelButtonColor: '#878a99',
    });
    if (!result.isConfirmed) return null;
    return String(result.value ?? '').trim();
  }

  private buildListingContextInputData(agentNotes?: string): string | undefined {
    const details = this.property?.details ?? {};
    const address = this.property?.address ?? {};
    const areas = this.property?.areasNearby ?? {};

    const context: Record<string, any> = {
      propertyType: this.firstNonEmpty(this.property?.propertyType?.description, details?.propertyTypeDescription),
      propertyTypeId: this.positiveInt(this.firstNonEmpty(details?.propertyType, this.property?.propertyType?.id)),
      condition: this.firstNonEmpty(this.property?.condition?.description, details?.conditionDescription),
      conditionId: this.positiveInt(this.firstNonEmpty(details?.condition, this.property?.condition?.id)),
      businessType: this.firstNonEmpty(this.property?.businessType?.description, details?.businessTypeDescription),
      businessTypeId: this.positiveInt(this.firstNonEmpty(details?.businessType, this.property?.businessType?.id)),
      yearOfConstruction: this.normalizeYear(this.firstNonEmpty(details?.yearOfConstruction, this.property?.yearOfConstruction)),
      price: this.positiveNumber(this.firstNonEmpty(details?.price, this.property?.price)),
      energyClass: this.firstNonEmpty(this.property?.ec?.description, details?.ecDescription, details?.ecCode),
      energyClassId: this.positiveInt(this.firstNonEmpty(details?.ec, this.property?.ec?.id)),
      district: this.firstNonEmpty(address?.districtName, this.property?.district?.name),
      county: this.firstNonEmpty(address?.countyName, this.property?.county?.name),
      parish: this.firstNonEmpty(address?.parishName, this.property?.parish?.name),
      address: this.firstNonEmpty(address?.address),
      zipCode: this.firstNonEmpty(address?.zipCode),
      areas: {
        usefulArea: this.positiveNumber(this.firstNonEmpty(areas?.usefulArea)),
        grossArea: this.positiveNumber(this.firstNonEmpty(areas?.grossArea)),
        grossPrivateArea: this.positiveNumber(this.firstNonEmpty(areas?.grossPrivateArea)),
        grossDependentArea: this.positiveNumber(this.firstNonEmpty(areas?.grossDependentArea)),
        landArea: this.positiveNumber(this.firstNonEmpty(areas?.landArea)),
        buildingImplantationArea: this.positiveNumber(this.firstNonEmpty(areas?.buildingImplantationArea)),
      },
      characteristics: this.firstNonEmpty(this.property?.charateristics, this.property?.characteristics, this.property?.features),
      agentNotes: agentNotes?.trim() ? agentNotes.trim().slice(0, 600) : undefined,
    };

    const cleaned = this.cleanPayload(context);
    return cleaned ? JSON.stringify(cleaned) : undefined;
  }

  canTranslateContent(): boolean {
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    if (!langs.length) return false;

    const mainLang =
      langs.find((lang: any) => this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true) ??
      langs[0];

    const mainLangId = mainLang?.id;
    if (!mainLangId) return false;

    const title = String(
      this.propertyAdvertisementForm?.get(`lang${mainLangId}_title`)?.value ?? '',
    ).trim();
    const descriptionLength = this.getDescriptionTextLength({ id: mainLangId });

    const hasTitle = title.length > 0 && title.toUpperCase() !== 'N/A';
    const hasDescription = descriptionLength > 0;

    return hasTitle && hasDescription;
  }

  translateContent() {
    if (!this.canUseAiService('TRANSLATION')) return;
    if (!this.canTranslateContent()) return;
    this.aiLoading['translate'] = true;
    this.aiTranslationPulse = false;
    this.aiService.executeAiService(
      'TRANSLATION',
      this.aiIdempotencyKey('translate'),
      this.property?.id,
      this.buildTranslationInputData(),
    ).subscribe({
      next: (res: any) => {
        this.aiLoading['translate'] = false;
        if (res?.ok && res?.output?.translations) {
          const changed = this.applyTranslations(res.output.translations);
          this.aiTranslationPulse = true;
          setTimeout(() => (this.aiTranslationPulse = false), 1400);
          this.setLatestResult(
            'TRANSLATION',
            this.translateService.instant('ai-feedback.resultTranslationHeadline'),
            this.translateService.instant('ai-feedback.resultTranslationDetail', { count: changed || 1 }),
          );
          return;
        }
        this.openGenericAiError(this.resolveErrorMessage(res));
      },
      error: (err: any) => {
        this.aiLoading['translate'] = false;
        this.openGenericAiError(this.resolveErrorMessage(err));
      },
    });
  }
}

